import "./App.css";
import Footer from "./components/Footer/footer";
import Hero from "./components/Hero/hero";
import Join from "./components/Join/join";
import Plan from "./components/Plans/plan";
import Programs from "./components/Programs/programs";
import Reason from "./components/Reason/reason";
import Testimonials from "./components/Testimonials/testimonials";

function App() {
  return (
    <div className="App">
      <Hero />
      <Programs />
      <Reason />
      <Plan />
      <Testimonials />
      <Join />
      <Footer />
    </div>
  );
}

export default App;
